import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import Login from './components/Login';
import Search from './components/Search';
import TeamPage from './components/TeamPage';
import UserPage from './components/UserPage';
import TopContainer from './components/TopContainer';
import ContentContainer from './components/ContentContainer';
import ProtectedRoute from './components/ProtectedRoute';
import Customers from './components/Customers';
import TrialCustomers from './components/TrialCustomers';
import Activity from './components/Activity';
import MrrPage from './components/MrrPage';


function App() {
  const { isAuthenticated } = useAuth();

  return (
    <Router>
      <TopContainer />
      <ContentContainer>
        <Routes>
          {/* Redirect "/" to "/home" for authenticated users */}
          <Route path="/" element={isAuthenticated ? <Navigate to="/home" /> : <Login />} />
          <Route path="/home" element={
            <ProtectedRoute>
              <Search />
            </ProtectedRoute>
          } />
          <Route path="/trialcustomers" element={
            <ProtectedRoute>
              <TrialCustomers />
            </ProtectedRoute>
          } />
          <Route path="/customers" element={
            <ProtectedRoute>
              <Customers />
            </ProtectedRoute>
          } />
          
          <Route path="/activity" element={
            <ProtectedRoute>
              <Activity />
            </ProtectedRoute>
          } />
           <Route path="/mrr" element={
            <ProtectedRoute>
              <MrrPage />
            </ProtectedRoute>
          } />
          <Route path="/team/:id" element={
            <ProtectedRoute>
              <TeamPage />
            </ProtectedRoute>
          } />
          <Route path="/user/:id" element={
            <ProtectedRoute>
              <UserPage />
            </ProtectedRoute>
          } />
          
        </Routes>
      </ContentContainer>
    </Router>
  );
}

export default App;
